// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from 'styled-components';

const HeaderContainer = styled.div.attrs({className: 'd-flex align-items-end'})`
  height: 70%;
`;

const StyledDiv = styled.div`
  margin-left: 10%;

  @media (max-width: 576px) {
    margin-left: unset !important;
  }
`;

const StyledImg = styled.img.attrs({className: 'mb-5 img-fluid'})``;

const HeaderContent = () => {
  return (
    <HeaderContainer>
      <StyledDiv>
        <StyledImg src="/assets/logo/logo_big.gif" alt="Logo" />
      </StyledDiv>
    </HeaderContainer>
  );
};

export default HeaderContent;
